import { columnSettings, tableWidth } from "./report-template-setting";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateTableHeader = () => {
  return (
    <tr
      id="report-column-header"
      className={`row-start-start ${tableWidth} text-sm bg-zinc-100 font-semibold text-slate-800 `}
    >
      <td
        className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border  px-2 h-full pb-2 pt-3 `}
      >
        {settings["no"].name}
      </td>

      <td
        className={`${settings["product_name"].layout} ${settings["product_name"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["product_name"].name}
      </td>

      <td
        className={`${settings["total_quantity"].layout} ${settings["total_quantity"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["total_quantity"].name}
      </td>

      <td
        className={`${settings["product_price"].layout} ${settings["product_price"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["product_price"].name}
      </td>

      <td
        className={`${settings["sub_total"].layout} ${settings["sub_total"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["sub_total"].name}
      </td>

      <td
        className={`${settings["discount"].layout} ${settings["discount"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["discount"].name}
      </td>

      <td
        className={`${settings["grand_total"].layout} ${settings["grand_total"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["grand_total"].name}
      </td>
    </tr>
  );
};

export default ReportTemplateTableHeader;
